import { Workspace } from './workspace';
import { Logging } from './utils/logging';

export default class Analytics {

    unfocusedCallback: () => void;
    inactivityCallback: () => void;
    cntClicks: number;
    isInactive: boolean;
    timerInactive: number;
    blocksDeletedCount: number;
    blocksTotalCount: number;
    projectResetCount: number;
    projectExecutionsCount: number;
    timeStart: number;

    static registerInactivity() {
        return 3;
    }

    constructor() {
        // Variables for analytics
        this.timeStart = Date.now();
        this.projectExecutionsCount = 0;
        this.projectResetCount = 0;
        this.blocksTotalCount = 0;
        this.blocksDeletedCount = 0;
        this.timerInactive = 0;
        this.isInactive = false;
        this.cntClicks = 0;
        this.inactivityCallback = () => Logging.silly("Inactivity detected.");
        this.unfocusedCallback = () => Logging.silly("Unfocus detected.");
        this.setupEvents();
    }

    // Resets all variables
    resetAll() {
        this.timeStart = Date.now();
        this.projectExecutionsCount = 0;
        this.projectResetCount = 0;
        this.blocksTotalCount = 0;
        this.blocksDeletedCount = 0;
        this.timerInactive = 0;
        this.isInactive = false;
        this.cntClicks = 0;
        Logging.debug("Analytics was reset.");
    }

    // Gets the exact time for the current session
    getTimeExact() {
        const timeElapsed = new Date(Date.now() - this.timeStart);
        if (timeElapsed.getTimezoneOffset() !== 0) {
            return "".concat("" + (timeElapsed.getHours() - Math.abs(timeElapsed.getTimezoneOffset()) / 60), " h ",
                "" + timeElapsed.getMinutes(), " m ", "" + timeElapsed.getSeconds(), " s");
        } else {
            return "".concat("" + timeElapsed.getHours(), " h ", "" + timeElapsed.getMinutes(),
                " m ", "" + timeElapsed.getSeconds(), " s");
        }
    }

    // Gets the passed minutes for the current session
    getTimeMinutes() {
        let timeElapsed = new Date(Date.now() - this.timeStart);
        if (timeElapsed.getTimezoneOffset() !== 0) {
            return (timeElapsed.getHours() - Math.abs(timeElapsed.getTimezoneOffset()) / 60)
                * 60 + timeElapsed.getMinutes();
        } else {
            return timeElapsed.getHours() * 60 + timeElapsed.getMinutes();
        }
    }

    // Calculates the clicks per minute
    getClicksPerMinute() {
        let minutes = this.getTimeMinutes();
        if (minutes > 0) {
            return Number((this.cntClicks / minutes).toFixed(1));
        } else {
            return this.cntClicks;
        }
    }

    // Getter and Setter methods for variables
    getProjectExecutionsCount() {
        return this.projectExecutionsCount;
    }

    addProjectExecutionsCount() {
        this.projectExecutionsCount += 1;
    }

    getProjectResetCount() {
        return this.projectResetCount;
    }

    addProjectResetCount() {
        this.projectResetCount += 1;
    }

    getBlocksTotalCount() {
        this.blocksTotalCount = 0;
        (window as any).workspaceManager.workspaces.forEach((workspace: Workspace) =>
            this.blocksTotalCount += workspace.blocklyWorkspace.getAllBlocks(false).length);
        return this.blocksTotalCount;
    }

    getBlocksDeletedCount() {
        return this.blocksDeletedCount;
    }

    addBlocksDeletedCount(value: number) {
        this.blocksDeletedCount += value;
    }

    // Handles inactivity and counter for clicks
    setupEvents() {
        setInterval(this.timerIncrement.bind(this), 20000); // 20 seconds

        document.addEventListener('keyup', () => this.resetInactivity());
        document.addEventListener('mousemove', () => this.resetInactivity());
        document.addEventListener('mousemove', () => this.resetInactivity());
        document.addEventListener("mouseup", () => {
            this.resetInactivity();
            this.cntClicks++;
        });

        window.addEventListener("blur", () => {
            if ((this.unfocusedCallback != null) && (this.unfocusedCallback instanceof Function)) {
                this.unfocusedCallback();
            }
        });
    }

    // Resets timer and flag for inactivity
    resetInactivity() {
        this.timerInactive = 0;
        this.isInactive = false;
    }

    // Incrementing idle time counter at each interval
    timerIncrement() {
        this.timerInactive++;
        if (this.timerInactive >= Analytics.registerInactivity() * 3) {
            if ((this.inactivityCallback != null) && (this.inactivityCallback instanceof Function)
                && (!this.isInactive)) {
                this.isInactive = true;
                this.inactivityCallback();
            }
        }
    }
}
